import { render, staticRenderFns } from "./UpdateUserLabelModal.vue?vue&type=template&id=2277d079&scoped=true&"
import script from "./UpdateUserLabelModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserLabelModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateUserLabelModal.vue?vue&type=style&index=0&id=2277d079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277d079",
  null
  
)

export default component.exports